import styles from './AccessAppPermission.css'
import _ from 'lodash'
import Row from './Row'
class AccessAppPermission extends React.Component {
  render () {
    return (
      <div className={`row ${styles['access-app-permission-container']}`}>
        <div className='col-lg-1' />
        <div className='col-lg-11'>
          <div className='row'>
            {this.props.permissions.map(permission => {
              return (
                <Row
                  checked={this._isChecked(permission)}
                  onChangeCheckbox={this._onChangeCheckbox}
                  permission={permission}
                />
              )
            })}
          </div>
          <div style={{fontStyle: 'italic'}} className='row'>
            *Mandatory to make transaction on app
          </div>
        </div>
      </div>
    )
  }

  _isChecked = (permission) => {
    const {fields} = this.props
    const currentValue = fields.getAll()
    return _.findIndex(currentValue, {'id': permission.id}) !== -1
  }

  _onChangeCheckbox = (permission) => {
    const {fields} = this.props
    const currentValue = fields.getAll()
    const index = _.findIndex(currentValue, {'id': permission.id})
    if (index === -1) {
      fields.push(permission)
    } else {
      fields.remove(index)
    }
  }
}

export default AccessAppPermission



// WEBPACK FOOTER //
// ./app/pages/Employees/Role/RoleDetail/RoleForm/AccessAppPermission/AccessAppPermission.js